const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/ui.ts';
import Imm from 'immutable';
import { IActionHandlersMap, makeReducer, ReducerState } from '@cistec/common_web/defs/actionTypes';
import {
    ACTION_TYPE_INVITATION_CODE,
    ACTION_TYPE_PATAPP_MAINNAV_COLLAPSE,
    ACTION_TYPE_PATAPP_MAINNAV_EXPAND,
    ICollapseMainNavAction,
    IExpandMainNavAction,
    InvitationCodeAction,
    PATAPP_ADD_SNACKBAR,
    PATAPP_REMOVE_SNACKBAR,
} from 'App/actions/ui';
import { ACTION_TYPE_PATAPP_ECHECKIN_PROGRESS_ACTION, IEcheckInProgressAction } from 'App/components/eCheckin/actions';
import {
    initialState as commonInitialState,
    uiReducer as commonUiReducer,
} from '@cistec/common_web/reducers/uiReducer';
import { AddSnackbarAction, RemoveSnackbarAction, typeSnackbarActionPayload } from 'App/actions/snackbar';
import _ from 'lodash';
import { typeAlertActionPayload } from 'App/actions/alert';
import { createSelector } from 'reselect';
import { PatAppStoreState } from './setup/rootReducer';

const handlers: IActionHandlersMap = {
    [ACTION_TYPE_PATAPP_MAINNAV_EXPAND]: (state, _action: IExpandMainNavAction) => {
        return state.set('isMainNavExpanded', true);
    },
    [ACTION_TYPE_PATAPP_MAINNAV_COLLAPSE]: (state, _action: ICollapseMainNavAction) => {
        return state.set('isMainNavExpanded', false);
    },
    [ACTION_TYPE_PATAPP_ECHECKIN_PROGRESS_ACTION]: (state, action: IEcheckInProgressAction) => {
        return state.set('percentFinished', action.percentFinished);
    },
    [PATAPP_ADD_SNACKBAR]: (state, action: AddSnackbarAction) => {
        // set default value for action.payload.addMultiple
        if (action.payload.canAddMultiple === undefined) {
            action.payload.canAddMultiple = true;
        }

        const snackbarList: typeSnackbarActionPayload[] = _.cloneDeep(state.get('snackbarList') || []);
        let shouldAddPayload = true;

        // prevent snackbar spamming
        if (
            !action.payload.canAddMultiple &&
            snackbarList.find(
                entry => entry.message.id === action.payload.message.id && entry.color === action.payload.color
            )
        ) {
            shouldAddPayload = false;
        }

        if (shouldAddPayload) {
            snackbarList.push(action.payload);
        }
        return state.set('snackbarList', snackbarList);
    },
    [PATAPP_REMOVE_SNACKBAR]: (state, action: RemoveSnackbarAction) => {
        const snackbarList: any[] = state.get('snackbarList') || [];
        const filteredList = snackbarList.filter(value => value.id !== action.payload.id);
        return state.set('snackbarList', filteredList);
    },
    [ACTION_TYPE_INVITATION_CODE]: (state, action: InvitationCodeAction) => {
        return state.set('invitationCode', action.payload.invitationCode);
    },
};

export const uiReducer = makeReducer(
    handlers,
    commonInitialState.merge(
        Imm.fromJS({
            isMainNavExpanded: false,
            percentFinished: 0,
        })
    ),
    undefined,
    [],
    commonUiReducer
);

const selectReducerState = (state: PatAppStoreState): ReducerState => state.ui;

export const progressFinished = createSelector([selectReducerState], (state: ReducerState): number =>
    state.get('percentFinished')
);

export const isMainNavExpanded = createSelector([selectReducerState], (state: ReducerState): boolean =>
    state.get('isMainNavExpanded')
);

export const snackBarList = createSelector(
    [selectReducerState],
    (state: ReducerState): typeSnackbarActionPayload[] => state.get('snackbarList') || []
);

export const alertList = createSelector(
    [selectReducerState],
    (state: ReducerState): typeAlertActionPayload[] => state.get('alertList') || []
);

export const invitationCode = createSelector([selectReducerState], (state: ReducerState): string | undefined =>
    state.get('invitationCode')
);
